import React from "react";

const SpecTable = ({ specs }) => {
  const baseClass = 'font-medium p-2 md:px-4';
  
  return (
    <div className='md:col-span-2 grid grid-cols-3 md:grid-cols-2 gap-y-4 border border-mainBlue rounded-xl'>
      {specs.map(({ label, value, highlight }, idx) => {
        const cellClass = highlight ? `${baseClass} bg-mainBlue-1` : baseClass;
        return (
          <React.Fragment key={idx}>
            <p className={`${cellClass} `}>{label}</p>
            <p className={`${cellClass} col-span-2 md:col-span-1 whitespace-pre-line`}>{value}</p>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default SpecTable;
